import { render, staticRenderFns } from "./view_validation_rule.vue?vue&type=template&id=239583b2&scoped=true"
import script from "./view_validation_rule.vue?vue&type=script&lang=js"
export * from "./view_validation_rule.vue?vue&type=script&lang=js"
import style0 from "./view_validation_rule.vue?vue&type=style&index=0&id=239583b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239583b2",
  null
  
)

export default component.exports